export default {
    namespaced: true,

    state: () => {
        return { testCases: [], selectedTestCase: null }
    },

    mutations: {
        updateTestCases(state, testCases) {
            state.testCases = testCases || []
        },

        setSelectedTestCase(state, testCase) {
            state.selectedTestCase = testCase
        }
    },
}
